import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-arc42-leitfaden',
  standalone: true,
  imports: [],
  templateUrl: './arc42-leitfaden.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './arc42-leitfaden.component.scss'
})
export class Arc42LeitfadenComponent {

}
